import { APIClient } from "../helpers/api_helper";
import { GET_DEVELOPER_DEVICES } from "../helpers/url_helper";

const api = new APIClient();

export const getDevicesByDeveloper = async () => {
    return await api.get(GET_DEVELOPER_DEVICES);
};

